import React, { createContext, useContext, useState, useRef, useCallback, useMemo } from 'react';
import _ from 'lodash';

export const BlumeFormContext = createContext({});

const BlumeFormProvider = ({ children }) => {
	const [pdfInstance, setPdfInstance] = useState(null);
	const pdfDataRef = useRef(null);

	// Create data ref when user input on the form
	const debounceSetPDFAnnotData = useCallback(
		_.debounce(async () => {
			if (pdfInstance) {
				const { documentViewer, annotationManager } = pdfInstance.Core;
				const xfdfString = await annotationManager.exportAnnotations();
				const doc = documentViewer.getDocument();
				const data = await doc.getFileData({ xfdfString });
				console.log('test data : ', data);
				pdfDataRef.current = data;
			}
		}, 300),
		[pdfInstance]
	);

	// Reset context
	const resetForm = () => {
		pdfDataRef.current = null;
		setPdfInstance(null);
	};

	const values = useMemo(
		() => ({
			pdfInstance,
			setPdfInstance,
			pdfDataRef,
			debounceSetPDFAnnotData,
			resetForm,
		}),
		[pdfInstance, pdfDataRef]
	);
	return <BlumeFormContext.Provider value={values}>{children}</BlumeFormContext.Provider>;
};

export const useBlumeFormContext = () => useContext(BlumeFormContext);
export default BlumeFormProvider;
